import type { ICellRendererParams } from 'ag-grid-community'
import { CheckCircleIcon } from '@phosphor-icons/react/dist/ssr/CheckCircle'
import { CircleIcon } from '@phosphor-icons/react/dist/ssr/Circle'

export function PromotedCellRenderer(
  params: ICellRendererParams<unknown, unknown>,
) {
  return params.value ? <CheckCircleIcon /> : <CircleIcon />
}
